import React, {useEffect, useState} from 'react';

// custom components
import {Footer, Text, PageNavigator } from '../../components/atoms';
import { ApiTitle, TabList, List, TableNumber, Callout, RequestHeader, RequestFields, HttpRequest} from '../../components/molecules';

// bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import SwaggerUI from "swagger-ui-react";

// custom components
import { Maintenance } from '../../components/atoms';
import { IntegrationRow } from '../../components/organisms'

// code
import sample from '../../utils/code/postBookingBody';
import { CopyBlock, dracula} from "react-code-blocks";

// utils
import { Colors } from '../../styles';

// images
import DeletedAirlineBooking from '../../assets/images/delete-booking/delete.png';
import DeletedPRMBooking from '../../assets/images/delete-booking/delete-prm-booking.png';

const DeleteBooking = (props) => {

    const [tab, setTab] = useState(0)

    useEffect(() => {

    }, []);

    const TitleText = (props) => { return ( <p style={{ fontWeight:'bold', fontSize:14 }}>{props.children}</p>)}
    const TextText = (props) => { return ( <p style={{ fontWeight:'300', fontSize:14 }}>{props.children}</p>)}

    const ExampleBookingTable = (props) => {

        const Row = (props) => { return (
            <tr>
                <td><TitleText>{props.data}</TitleText></td>
                <td><TextText>{props.example}</TextText></td>
            </tr>
        )}

        return (
            <div style={{ }}>
                <table class="table" style={{ }}>
                        <thead style={{}}>
                            <tr style={{backgroundColor:Colors.PRM_LIGHT_BLUE}}>
                                <th style={{fontWeight:'bold', fontSize:14, color:'white' }} scope="col">Data</th>
                                <th style={{fontWeight:'bold', fontSize:14, color:'white' }} scope="col">Value</th>
                            </tr>
                        </thead>
                    <tbody>
                        <tr>
                            <td><TitleText>{'Booking Id'}</TitleText></td>
                            <td><TextText>{'EI205-2022-01-01-joe-bloggs'}</TextText></td>
                        </tr>
                        <Row data={'Passenger Name'} description={'The name of the passenger'} example={'Mr. Joe Bloggs'} required={'Yes'} />
                        <Row data={'Origin Airport IATA'} description={'The IATA code of the origin airport'} example={'DUB'} required={'Yes'} />
                        <Row data={'Destination Airport IATA'} description={'The IATA code of the destination airport'} example={'JFK'} required={'Yes'} />
                        <Row data={'Flight Number'} description={'The flight number of the route'} example={'EI105'} required={'Yes'} />
                        <Row data={'Departure Date'} description={'The departure date of the flight'} example={'07-12-2022'} required={'Yes'} />
                        <Row data={'Assistance Requested'} description={'A list of SSR codes.'} example={'[ Wheelchair Access, Impaired Eyesight]'} required={'Yes'} />
                        <Row data={'Equipment Information'} description={'Details of the passengers wheelchair equipment'} example={'Make, Model, Weight, Battery etc.'} required={'Optional'} />
                        <Row data={'Service Animal'} description={'Wether or not the passenger is accomponanied by a service animal'} example={'False'} required={'Optional'} />
                    </tbody>
                </table>
            </div>
        )
    }

    const ResponseTable = (props) => {
        return (
            <div>
                <table class="table" style={{ }}>
                    <thead style={{}}>
                        <tr style={{backgroundColor:Colors.PRM_LIGHT_BLUE}}>
                            <th style={{fontWeight:'bold', fontSize:14, color:'white' }} scope="col"><Text.TableHeader>Code</Text.TableHeader></th>
                            <th style={{fontWeight:'bold', fontSize:14, color:'white' }} scope="col"><Text.TableHeader>Description</Text.TableHeader></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td scope="col"><Text.TableHeader bold={true}>201 Ok</Text.TableHeader></td>
                            <td scope="col"><Text.TableBody>{'Indicates that the booking was deleted successfully'}</Text.TableBody></td>
                        </tr>
                        <tr>
                            <td scope="col"><Text.TableHeader bold={true}>400 Bad Request</Text.TableHeader></td>
                            <td scope="col"><Text.TableBody>Indicates that there was an error in the request. </Text.TableBody></td>
                        </tr>
                        <tr>
                            <td scope="col"><Text.TableHeader bold={true}>403 Unauthorized Access</Text.TableHeader></td>
                            <td scope="col"><Text.TableBody>{'Indicates that the request is unauthorized. Typically the result of not including the Authorization header in the request.'}</Text.TableBody></td>
                        </tr>
                        <tr>
                            <td scope="col"><Text.TableHeader bold={true}>404 Not Found</Text.TableHeader></td>
                            <td scope="col"><Text.TableBody>Indicates that the requested booking was not found.</Text.TableBody></td>
                        </tr>
                        <tr>
                            <td scope="col"><Text.TableHeader bold={true}>500 Internal Server Error</Text.TableHeader></td>
                            <td scope="col"><Text.TableBody>{'Indicates that the request did not go through due to an internal error.'}</Text.TableBody></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }

    return (
        <>
            {/* Title and Prerequisities */}
            <Row className='mt-5'>
                <Col>
                    <ApiTitle 
                        smallTitle={'Delete Request'}
                        title={'Deleting a booking'}
                        subtitle={'Use this guide to learn how to delete a PRM booking from our database.'}
                        prerequisites={[
                            'JSON Web Token',
                            'Booking ID'
                        ]}
                    />
                </Col>
            </Row>

            {/* Overview */}
            <Row>
                <Col>
                    <Text.Subheading>Overview</Text.Subheading>
                    <Text.Text>{`In this section, we aim to delete bookings using the PRM Connect Databse. This could help airlines alter bookings which have been cancelled.`}</Text.Text>
                </Col>
            </Row>
            
            {/* Selector Tab List */}
            <Row>
                <Col>
                    <TabList 
                        tabs={['Overview', 'Example', 'Implementation', 'Integration']}
                        setTab={(value)=>{ setTab(value)}}
                    />
                </Col>
            </Row>

            { tab == 1 && 
            <>
            <Row className='mt-4'>
                <Col>
                    <Container>
                        <Text.Subheading>1. Authorization</Text.Subheading>
                        <Text.Text>{'Authentication is achieved by means of a JSON Web Token: '}</Text.Text>
                        <Container>
                            <List list={['Bearer <token>']} />
                        </Container>
                    </Container>
                </Col>
            </Row>

            {/* 2. Booking Information */}
            <Row className='mt-3'>
                <Col>
                    <Container>
                        <Text.Subheading>2. Booking Information</Text.Subheading>
                        <Text.Text>{'In order to delete a specific booking using PRM Connect, a unique id must be used to retrieve the booking. This unique id is typically made up of '}</Text.Text>
                        <Container>
                            <List list={['Flight Number', 'Flight Date', 'Passenger Name']} />
                        </Container>    
                        <Text.Text>{'The table and code below show a typical booking object, examine the Booking Id in 2.1 and the _id in 2.2'}</Text.Text>                
                    </Container>
                </Col>
            </Row>
            <Row className='mt-4'>
                <Col>
                    <Container>
                        <TableNumber title={'2.1 Booking'} description={'Example of a booking stored in the database'} />
                        <ExampleBookingTable />
                    </Container>
                </Col>
                <Col>
                    <Container>
                        <TableNumber title={'2.2 Example JSON'} description={'Example of a booking response from the database'} />
                        <CopyBlock
                            language={'json'}
                            text={sample['exampleBookingDatabase']}
                            showLineNumbers={false}
                            theme={dracula}
                            wrapLines={false}
                        />
                    </Container>
                </Col>
            </Row>

            {/* 3. Request */}
            <Row className='mt-5'>
                <Col>
                    <Container>
                        <Text.Subheading>3. Request</Text.Subheading>
                        <Text.Text>{'This section describes the Delete Booking request with a detailed API structure, an example request and response, JSON schemas for request, responses and error response codes.'}</Text.Text>              
                    </Container>
                </Col>
            </Row>
            
            {/* 3.1 Headers */}
            <Row className='mt-2'>
                <Col>
                    <Container>
                        <Text.Subheading>3.1 Header</Text.Subheading>
                        <Text.Text>{'The request contains the following headers:'}</Text.Text>
                        <RequestHeader contentType={false} />
                    </Container>
                </Col>
            </Row>

            {/* 3.2 Fields of Request */}
            <Row className='mt-2'>
                <Col>
                    <Container>
                        <Text.Subheading>3.1 Fields of Request</Text.Subheading>
                        <Text.Text>{'The request contains the following fields:'}</Text.Text>
                        <RequestFields rows={[
                            { parameter:'id', description:'The id of the booking to return', example:'EI205-2022-01-01-joe-bloggs', optional:'Required'}
                        ]}
                        />
                    </Container>
                </Col>
            </Row>

            {/* 3.2 Body */}
            <Row className='mt-2'>
                <Col>
                    <Container>
                        <Text.Subheading>3.2 Request Body</Text.Subheading>
                        <Text.Text>{'The request body is empty.'}</Text.Text>
                    </Container>
                </Col>
            </Row>

            {/* 3.3 Response */}
            <Row className='mt-2'>
                <Col>
                    <Container>
                        <Text.Subheading>3.3 Request Response</Text.Subheading>
                        <Text.Text>{'This section reviews the different responses and their meaning.'}</Text.Text>
                        <ResponseTable />
                    </Container>
                </Col>
            </Row>
            </>
            }

            { tab == 2 &&
            <>
            <Row className='mt-4'>
                <Col >
                   <Container>

                       {/* Text */}
                       <Text.Subheading>1. Example Request</Text.Subheading>
                       <Text.Text>{'This section contains an example of requesting a passenger booking deletion using the booking id.'}</Text.Text>

                       <Text.Subsubheading>1.1 Deleting a booking request</Text.Subsubheading>
                       <Text.Text>{'In this example we delete a booking for a passenger, Joe Bloggs.'}</Text.Text>
                       <HttpRequest 
                            requestType={'DELETE'}
                            url={'https://connect.prmassist.com/api/v1/bookings/EI205-2022-01-01-joe-bloggs'}
                            headers={['Authorization: Bearer <token>']}
                        />
                   </Container>
               </Col>
           </Row>
            <Row className='mt-2'>
                <Col>
                    <Container>
                        <TableNumber title={'1.1 Request Response'} description={'Displays the response from the above request'} />
                        <CopyBlock
                            language={'json'}
                            text={sample['deleteBooking']}
                            showLineNumbers={false}
                            theme={dracula}
                            wrapLines={false}
                        />
                    </Container>
                </Col>
            </Row>
            </>
            }

            { tab === 3 &&
            <>
                <Row className='mt-4'>
                    <Col>
                        <Container>
                            <Text.Subheading>Swagger Implementation</Text.Subheading>
                            <Text.Text>{'This section contains a swagger that can be used for deleting a single booking using a booking id, reviewing the different responses and error codes'}</Text.Text>
                            <SwaggerUI url="delete_booking.yaml" />
                        </Container>
                    </Col>
                </Row>
            </>
            }
            
            {/* Implementation */}
            { tab === 4 &&
            <>
                <IntegrationRow 
                    title={'1. Deleted Booking'}
                    description={'In this section, a passenger has made an assistance booking which is then canceled. We outline how the API works to handle this scenario. There are two scenarios where a booking can be deleted:'}
                    other={<List list={['A Passenger Deletes a Booking with the Airline', 'A Passenger Deletes a Booking with PRM Assist' ]} />}
                />
                <IntegrationRow 
                    title={'1.1 A Passenger Deletes a Booking with the Airline'}
                    description={'If a passenger deletes a booking with the airline, the airline should call the DELETE request to delete the booking from the database.'}
                    description2={'The booking will be deleted from the PRM Assist database and a response will be sent to the client to let them know the request was performed successfully.'}
                    imageTitle={<TableNumber title={'1.1 Deleted Airline Booking'} description={'Example of a booking stored in the airline database being deleted from the PRM Connect database'} />}
                    image={<img
                        src={DeletedAirlineBooking}
                        width="1000px"
                        className="d-inline-block align-top"
                        alt=""
                        style={{}}
                    />}
                />
                <IntegrationRow 
                    title={'1.2 A Passenger Deletes a Booking with PRM Assist'}
                    description={'If a passenger deletes a booking with PRM Assist, the airline will be updated of the deleted booking the next time they request the bookings.'}
                    description2={<Text.Title>Example</Text.Title>}
                    example1={'Passenger Joe Bloggs creates an assistance booking using the PRM Assist App for their Aer Lingus flight on the 20th of January. On the 9th of January Aer Lingus query PRM Connect to get new bookings. 225 Bookings are returned, one of which is Joe Blogg’s booking. On the 10th of January he changes his flight and subsequently deletes this booking from his app.'}
                    example2={'Aer Lingus then query PRM Connect to get the bookings and to get a list of deleted and edited bookings. A list of deleted bookings is returned, including Joe Blogg’s booking.'}
                    imageTitle={<TableNumber title={'1.2 Deleted PRM Connect Booking'} description={'Example of a booking stored in the PRM Connect database being deleted from the Airline database'} />}
                    image={<img
                        src={DeletedPRMBooking}
                        width="1000px"
                        className="d-inline-block align-top"
                        alt=""
                        style={{ marginBottom: 12}}
                    />}
                    imageDescription={'Aer Lingus can now update their stored bookings and remove Joe Blogg’s booking using his reference number. Aer Lingus’ database has now been fully updated with the changes to the PRM Assist Database.'}
                />  
            </>
            }

            {/* Page Navigator */}
            <Row>
                <Col>
                    <Container>
                        <PageNavigator leftText={'Update Bookings'} leftLink={'/update-bookings'} right={false} />
                    </Container>
                </Col>
            </Row>
            
            <Footer small={true} />
        </>
    );
};

export default DeleteBooking;
